export const getRootDomain = (hostname = window.location.hostname): string => {
  const parts = hostname.split('.');

  if (parts.length > 2) {
    return parts.slice(-2).join('.');
  }
  return hostname;
};
